<template>
    <div class="page">
        <h1>This is an other-initiatives page</h1>
        <enfooter></enfooter>

    </div>
</template>

<script>
    import enfooter from '@/components/enfooter.vue'

    export default {
        name: 'other-initiatives',
        components: {
            enfooter
        }
    }
</script>

